import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  public Get(keyName: string) {
    return localStorage.getItem(keyName) || undefined;
  }

  public Set(keyname: string, data: any, stringify: boolean) {

    localStorage.setItem(keyname, (stringify) ? JSON.stringify(data) : data);
    return true;
  }

  public Clear() {
    localStorage.clear();
    return true;
  }

  public RemoveItem(keyName: string) {
    localStorage.removeItem(keyName);
    return true;
  }
}
